import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

export default function Projects() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  return (
    <section id="projets" data-testid="projects-section" className="section bg-ink text-bone">
      <div className="container-max">
        <div className="grid grid-cols-12 gap-8 mb-16 items-end">
          <div className="col-span-12 md:col-span-8">
            <p className="overline text-bone/60">— Projets</p>
            <h2 className="font-display font-light text-5xl md:text-7xl leading-[0.95] tracking-tighter mt-6">
              Un fragment de notre journal d'atelier.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:text-right">
            <p className="text-bone/60">187 livraisons depuis 2014, dont une sélection ci-dessous.</p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {projects.map((p, i) => {
            const span =
              i % 5 === 0 ? "md:col-span-8" :
              i % 5 === 1 ? "md:col-span-4" :
              i % 5 === 2 ? "md:col-span-5" :
              i % 5 === 3 ? "md:col-span-7" :
              "md:col-span-6";
            const ratio = i % 3 === 0 ? "aspect-[16/10]" : i % 3 === 1 ? "aspect-[4/5]" : "aspect-[5/4]";
            return (
              <motion.article
                key={p.slug}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.9, delay: (i % 3) * 0.1 }}
                className={`col-span-12 ${span} group`}
                data-testid={`project-card-${p.slug}`}
              >
                <div className={`overflow-hidden ${ratio} bg-coal`}>
                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-cover img-zoom"
                    loading="lazy"
                  />
                </div>
                <div className="mt-5 flex items-start justify-between gap-4">
                  <div>
                    <p className="overline text-bone/50">{p.district} · {p.surface} m² · {p.year}</p>
                    <h3 className="font-display text-2xl md:text-3xl mt-2">{p.title}</h3>
                    <p className="mt-2 text-bone/65 max-w-xl">{p.summary}</p>
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-bone/50 group-hover:text-terracotta transition-colors" />
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
